<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __OrderFilters, {OrderFilters as _OrderFilters} from '~/components/account/filters/OrderFilters.vue'

    @Component({mixins: [__OrderFilters]})
    export class OrderFilters extends _OrderFilters {
        // Override availableFilters to hide specific fields for ZSH
        get availableFilters() {
            const filters = {}

            // Filters to hide for ZSH (always hidden)
            const hiddenFiltersForZSH = [
                'supplierRef',
                'serviceTypes',
                'serviceName',
                'city',
                'customerInvoiceStatuses',
                'supplierInvoiceStatuses',
            ]

            this.filtersList.forEach(item => {
                filters[item.value] =
                    !this.hiddenFilters?.filters?.includes(item.value) && !hiddenFiltersForZSH.includes(item.value)
            })

            return filters
        }
    }

    export default {...toNative(OrderFilters), ssrRender: __OrderFilters.ssrRender}
</script>
